export class DocumentIntelligenceModelFilter {
    CompanyId?: number;

    constructor(companyId?: number) {
        this.CompanyId = null;

        if (companyId) {
            this.CompanyId = companyId;
        }
    }
}